import React from 'react';

const PdpSharedShippingDetailsLazyComponent = React.lazy(() =>
    import(/* webpackChunkName: "PdpSharedShippingDetails" */ './PdpSharedShippingDetails')
);

export const PdpSharedShippingDetailsLazy = props => (
    <React.Suspense fallback="">
        <PdpSharedShippingDetailsLazyComponent {...props} />
    </React.Suspense>
);
